import React, {useEffect, useState} from "react";
import ChatBox from "./ChatBox";
import "./ChatBox.css";

const ChatBoxBtn = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [minimizeChat, setMinimizeChat] = useState(true);
    const [messages, setMessages] = useState();
    const [userId, setUserId] = useState('');


    const maximizeAndMinimizeHandleChangeBtn = () => {
        if (!modalOpen) {
            setModalOpen(true);
            props.fetchTokenAndSave();
            const id = "WEBB" + Math.floor(Date.now())
            setUserId(id);
        }
        setMinimizeChat(!minimizeChat);
        if (!minimizeChat) {
        }
    }

    useEffect(() => {

        if (props.firstMessage)
            setMessages(props.firstMessage)
    }, [])

    const closeChatWindow = (cacheName) => {
        setModalOpen(false)
        setMinimizeChat(true)
        localStorage.clear();
        setMessages('');
        if ("caches" in window) {
            caches.delete(cacheName).then(function (res) {
                return res;
            });
        }
    }

    return (
        <div>
            <div className="ModalBtn" onClick={maximizeAndMinimizeHandleChangeBtn}>
                <img src={require("./img/virat@3x.webp")} alt="" className="virat"/>
                <div className="Rectangle">
                    <img src={require("./img/chat.webp"
                    )} className="chat" alt=""/>
                    <span className="Ask-Virat-new">
            Ask Virat
          </span>
                </div>

            </div>
            <ChatBox
                setMinimizeChat={setMinimizeChat}
                firstMessage={props.firstMessage}
                notifyClose={minimizeChat}
                olderMessages={messages}
                setOlderMessages={setMessages}
                closeChatWindow={closeChatWindow}
                id={userId}
                setmessageType={props.setmessageType}
                messageType={props.messageType}
                setUserId={setUserId}
                loader={props.loader}
            />

        </div>
    );
};

export default ChatBoxBtn;




// WEBPACK FOOTER //
// ./src/components/website-bot/ChatBoxBtn.js